module.exports = __webpack_public_path__ + "site/img/57.7035af39.jpg";